import React from 'react'
import View from './ChatRoom.view'
import { useChatRoom } from 'context/ChatRoom'

export default function ChatRoomLogic() {
  const { threads, roomId } = useChatRoom()
  return <View threads={threads} roomId={roomId} />
}
